export interface SharedUser {
  email: string;
  name: string;
  role: "owner" | "editor" | "viewer";
  sharedAt: string;
}

export interface Document {
  id: number;
  name: string;
  type: "pdf" | "document" | "spreadsheet" | "image";
  size: string;
  modified: string;
  author: string;
  status: "active" | "draft" | "archived";
  favorite?: boolean;
  folder: string;
  shared: SharedUser[];
}

export const mockDocuments: Document[] = [
  {
    id: 1,
    name: "Договір оренди.docx",
    type: "document",
    size: "2.4 MB",
    modified: "2024-03-15T10:00:00",
    author: "Іван Петренко",
    status: "active",
    favorite: true,
    folder: "Договори",
    shared: [
      {
        email: "maria@example.com",
        name: "Марія Коваленко",
        role: "editor",
        sharedAt: "2024-03-15T10:30:00"
      },
      {
        email: "anna@example.com",
        name: "Анна Менеджер",
        role: "viewer",
        sharedAt: "2024-03-15T11:00:00"
      }
    ]
  },
  {
    id: 2,
    name: "Акт прийому-передачі.pdf",
    type: "pdf",
    size: "1.2 MB",
    modified: "2024-03-14T15:30:00",
    author: "Марія Коваленко",
    status: "draft",
    folder: "Акти",
    shared: []
  },
  {
    id: 3,
    name: "Технічний паспорт.pdf",
    type: "pdf",
    size: "3.8 MB",
    modified: "2024-03-13T09:45:00",
    author: "Петро Майстренко",
    status: "archived",
    folder: "Технічна документація",
    shared: [
      {
        email: "ivan@example.com",
        name: "Іван Петренко",
        role: "viewer",
        sharedAt: "2024-03-13T10:00:00"
      }
    ]
  },
  {
    id: 4,
    name: "Звіт за березень 2024.xlsx",
    type: "spreadsheet",
    size: "1.8 MB",
    modified: "2024-03-12T14:20:00",
    author: "Анна Менеджер",
    status: "active",
    folder: "Звіти",
    shared: [
      {
        email: "ivan@example.com",
        name: "Іван Петренко",
        role: "editor",
        sharedAt: "2024-03-12T15:00:00"
      },
      {
        email: "maria@example.com",
        name: "Марія Коваленко",
        role: "viewer",
        sharedAt: "2024-03-12T15:30:00"
      }
    ]
  },
  {
    id: 5,
    name: "План приміщення.pdf",
    type: "pdf",
    size: "5.2 MB",
    modified: "2024-03-11T11:15:00",
    author: "Петро Майстренко",
    status: "active",
    favorite: true,
    folder: "Технічна документація",
    shared: []
  },
  {
    id: 6,
    name: "Інвентаризація 2024.xlsx",
    type: "spreadsheet",
    size: "2.1 MB",
    modified: "2024-03-10T16:40:00",
    author: "Анна Менеджер",
    status: "draft",
    folder: "Звіти",
    shared: [
      {
        email: "ivan@example.com",
        name: "Іван Петренко",
        role: "viewer",
        sharedAt: "2024-03-10T17:00:00"
      }
    ]
  },
  {
    id: 7,
    name: "Фото пошкоджень.jpg",
    type: "image",
    size: "4.5 MB",
    modified: "2024-03-09T13:25:00",
    author: "Марія Коваленко",
    status: "active",
    folder: "Фотографії",
    shared: [
      {
        email: "petro@example.com",
        name: "Петро Майстренко",
        role: "viewer",
        sharedAt: "2024-03-09T14:00:00"
      }
    ]
  },
  {
    id: 8,
    name: "Договір на ремонт.docx",
    type: "document",
    size: "1.9 MB",
    modified: "2024-03-08T09:30:00",
    author: "Іван Петренко",
    status: "draft",
    folder: "Договори",
    shared: []
  },
  {
    id: 9,
    name: "Кошторис ремонту.xlsx",
    type: "spreadsheet",
    size: "1.6 MB",
    modified: "2024-03-07T15:50:00",
    author: "Петро Майстренко",
    status: "active",
    folder: "Фінанси",
    shared: [
      {
        email: "anna@example.com",
        name: "Анна Менеджер",
        role: "editor",
        sharedAt: "2024-03-07T16:00:00"
      }
    ]
  },
  {
    id: 10,
    name: "Страховий поліс.pdf",
    type: "pdf",
    size: "0.8 MB",
    modified: "2024-03-06T10:15:00",
    author: "Анна Менеджер",
    status: "active",
    favorite: true,
    folder: "Страхування",
    shared: [
      {
        email: "ivan@example.com",
        name: "Іван Петренко",
        role: "viewer",
        sharedAt: "2024-03-06T11:00:00"
      }
    ]
  },
  {
    id: 11,
    name: "Акт виконаних робіт.pdf",
    type: "pdf",
    size: "1.4 MB",
    modified: "2024-03-05T14:20:00",
    author: "Петро Майстренко",
    status: "draft",
    folder: "Акти",
    shared: [
      {
        email: "anna@example.com",
        name: "Анна Менеджер",
        role: "editor",
        sharedAt: "2024-03-05T15:00:00"
      }
    ]
  },
  {
    id: 12,
    name: "Фото після ремонту.jpg",
    type: "image",
    size: "3.2 MB",
    modified: "2024-03-04T16:30:00",
    author: "Марія Коваленко",
    status: "active",
    folder: "Фотографії",
    shared: [
      {
        email: "petro@example.com",
        name: "Петро Майстренко",
        role: "viewer",
        sharedAt: "2024-03-04T17:00:00"
      },
      {
        email: "ivan@example.com",
        name: "Іван Петренко",
        role: "viewer",
        sharedAt: "2024-03-04T17:30:00"
      }
    ]
  },
  {
    id: 13,
    name: "Гарантійний лист.docx",
    type: "document",
    size: "0.9 MB",
    modified: "2024-03-03T11:45:00",
    author: "Іван Петренко",
    status: "archived",
    folder: "Договори",
    shared: []
  },
  {
    id: 14,
    name: "Звіт за лютий 2024.xlsx",
    type: "spreadsheet",
    size: "2.3 MB",
    modified: "2024-03-02T09:20:00",
    author: "Анна Менеджер",
    status: "archived",
    folder: "Звіти",
    shared: [
      {
        email: "ivan@example.com",
        name: "Іван Петренко",
        role: "viewer",
        sharedAt: "2024-03-02T10:00:00"
      }
    ]
  },
  {
    id: 15,
    name: "План евакуації.pdf",
    type: "pdf",
    size: "2.7 MB",
    modified: "2024-03-01T13:10:00",
    author: "Петро Майстренко",
    status: "active",
    folder: "Технічна документація",
    shared: [
      {
        email: "anna@example.com",
        name: "Анна Менеджер",
        role: "editor",
        sharedAt: "2024-03-01T14:00:00"
      },
      {
        email: "maria@example.com",
        name: "Марія Коваленко",
        role: "viewer",
        sharedAt: "2024-03-01T14:30:00"
      }
    ]
  },
  {
    id: 16,
    name: "Інструкція з експлуатації.pdf",
    type: "pdf",
    size: "4.1 MB",
    modified: "2024-02-29T15:40:00",
    author: "Петро Майстренко",
    status: "active",
    folder: "Технічна документація",
    shared: []
  },
  {
    id: 17,
    name: "Платіжна відомість.xlsx",
    type: "spreadsheet",
    size: "1.5 MB",
    modified: "2024-02-28T10:30:00",
    author: "Анна Менеджер",
    status: "draft",
    folder: "Фінанси",
    shared: [
      {
        email: "ivan@example.com",
        name: "Іван Петренко",
        role: "editor",
        sharedAt: "2024-02-28T11:00:00"
      }
    ]
  },
  {
    id: 18,
    name: "Фото фасаду.jpg",
    type: "image",
    size: "5.8 MB",
    modified: "2024-02-27T14:15:00",
    author: "Марія Коваленко",
    status: "active",
    favorite: true,
    folder: "Фотографії",
    shared: []
  },
  {
    id: 19,
    name: "Договір з підрядником.docx",
    type: "document",
    size: "2.2 MB",
    modified: "2024-02-26T11:20:00",
    author: "Іван Петренко",
    status: "active",
    folder: "Договори",
    shared: [
      {
        email: "anna@example.com",
        name: "Анна Менеджер",
        role: "editor",
        sharedAt: "2024-02-26T12:00:00"
      },
      {
        email: "petro@example.com",
        name: "Петро Майстренко",
        role: "viewer",
        sharedAt: "2024-02-26T12:30:00"
      }
    ]
  },
  {
    id: 20,
    name: "Специфікація обладнання.xlsx",
    type: "spreadsheet",
    size: "1.7 MB",
    modified: "2024-02-25T16:50:00",
    author: "Петро Майстренко",
    status: "active",
    folder: "Технічна документація",
    shared: [
      {
        email: "ivan@example.com",
        name: "Іван Петренко",
        role: "viewer",
        sharedAt: "2024-02-25T17:00:00"
      }
    ]
  },
  {
    id: 21,
    name: "Акт огляду приміщення.pdf",
    type: "pdf",
    size: "2.0 MB",
    modified: "2024-02-24T09:40:00",
    author: "Марія Коваленко",
    status: "draft",
    folder: "Акти",
    shared: [
      {
        email: "petro@example.com",
        name: "Петро Майстренко",
        role: "editor",
        sharedAt: "2024-02-24T10:00:00"
      }
    ]
  },
  {
    id: 22,
    name: "Бюджет на 2024.xlsx",
    type: "spreadsheet",
    size: "2.5 MB",
    modified: "2024-02-23T13:30:00",
    author: "Анна Менеджер",
    status: "active",
    favorite: true,
    folder: "Фінанси",
    shared: [
      {
        email: "ivan@example.com",
        name: "Іван Петренко",
        role: "editor",
        sharedAt: "2024-02-23T14:00:00"
      }
    ]
  },
  {
    id: 23,
    name: "Фото комунікацій.jpg",
    type: "image",
    size: "3.9 MB",
    modified: "2024-02-22T15:20:00",
    author: "Петро Майстренко",
    status: "active",
    folder: "Фотографії",
    shared: [
      {
        email: "anna@example.com",
        name: "Анна Менеджер",
        role: "viewer",
        sharedAt: "2024-02-22T16:00:00"
      }
    ]
  },
  {
    id: 24,
    name: "Довіреність.docx",
    type: "document",
    size: "1.1 MB",
    modified: "2024-02-21T10:10:00",
    author: "Іван Петренко",
    status: "archived",
    folder: "Договори",
    shared: []
  },
  {
    id: 25,
    name: "Звіт за січень 2024.xlsx",
    type: "spreadsheet",
    size: "2.0 MB",
    modified: "2024-02-20T14:45:00",
    author: "Анна Менеджер",
    status: "archived",
    folder: "Звіти",
    shared: [
      {
        email: "ivan@example.com",
        name: "Іван Петренко",
        role: "viewer",
        sharedAt: "2024-02-20T15:00:00"
      }
    ]
  }
]; 